import { Pipe, PipeTransform } from '@angular/core';
import { EsignField } from './esignature-setup.component';

@Pipe({
  name: 'layerFilter' 
})
export class LayerFilterPipe implements PipeTransform {
  transform(fields: EsignField[], layerNo: number): EsignField[] {
    if (!fields || !layerNo) {
      return [];
    }
    // Returns fields matched specifically to their selected workflow signing layers
    return fields.filter(field => field.layerNo === layerNo);
  }
}